export default "__VITE_ASSET__C6allSKG__"